import React from "react"

import style from "./index.module.sass"

// ----------------------------------------------------------------------------

function ServicesSearch(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { handleSearch, hasTitle = true } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function handleOnChange(event) {
    const query = event.target.value;
    handleSearch(query);
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <div>
      {hasTitle && <h3 className="cart-title">{I18n.t("search_service")}</h3>}
      <div className={`${style.searchContainer} ${hasTitle ? style.whiteBackground : ""}`}>
        <div className={`form-group m-0 ${style.inputContainer}`}>
          <input
            className={`form-control ${style.input}`}
            style={{border: "none"}}
            placeholder={I18n.t("search_service_placeholder")}
            onChange={handleOnChange}
          />
          <i className={`fal fa-search ${style.searchIcon}`}/>
        </div>
      </div>
    </div>
  )
}

// ----------------------------------------------------------------------------

export default ServicesSearch
